module.exports = __webpack_public_path__ + "static/media/StJohnsPreparatorySchool.d16cb836.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/StJohnsPreparatorySchool.jpg
// module id = 770
// module chunks = 0